import styled from 'styled-components';

import { scale160, scale250 } from '@xingternal/tokens';

export const GdprWrapper = styled.div`
  margin: ${scale250} auto ${scale160};
`;
